module.exports = __webpack_public_path__ + "assets/img/right-title-open-b930affd.png";